export function getSkuPrice(sku, prefix = 'Starts at ') {
  if (sku.showFree) return 'Free';
  if (sku.hasAdjustments) return `${prefix}${sku.startsAtPrice}`;
  return `${sku.startsAtPrice}`;
}
